import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DateModule } from '@epicuro-next/ataraxia/date';
import { IconsModule } from '@epicuro-next/ataraxia/icons';
import { TooltipDirective } from '@epicuro-next/ataraxia/tooltip';

import { DeliveryPeriodDateLabelComponent } from './delivery-period-date-label/delivery-period-date-label.component';
import { DeliveryPeriodComponent } from './delivery-period.component';

@NgModule({
  imports: [CommonModule, DateModule, IconsModule, TooltipDirective],
  exports: [DeliveryPeriodComponent, DeliveryPeriodDateLabelComponent],
  declarations: [DeliveryPeriodComponent, DeliveryPeriodDateLabelComponent],
  providers: [],
})
export class DeliveryPeriodModule {}
